class CustomSearch extends HTMLElement {
    constructor() {
        super()
        this.debounceTimer = null
        this.modal = null
        this.searchBar = null
        this.noResults = false
        // Get the current locale from the HTML lang attribute or URL
        this.locale = this.getLocale()
    }

    getLocale() {
        // Get current locale from Shopify
        const locale = window.Shopify?.locale
        // Check if locale exists in URL path
        const pathMatch = window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/)
        // Return locale prefix for URLs (empty if locale is not in path or is default)
        return pathMatch && pathMatch[1] === locale ? `/${locale}` : ''
    }

    connectedCallback() {
        this.modal = document.querySelector('#search-modal')
        this.searchBar = this.querySelector('#search-bar')

        setTimeout(() => {
            this.initMobileSearch()
        }, 100)

        // Add resize listener to handle viewport changes
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 989) {
                document.body.style.overflow = ''
            } else {
                // If back to mobile and modal is open, reapply mobile behavior
                const mobileSearchModal = document.querySelector('#mobile-search-modal')
                if (mobileSearchModal && mobileSearchModal.classList.contains('show')) {
                    document.body.style.overflow = 'hidden'
                    // Recalculate and update modal position
                    const announcementBar = document.querySelector('.announcement-bar-section, .announcement-bar')
                    const header = document.querySelector('.header, .section-header')
                    let topOffset = 0
                    if (announcementBar) topOffset += announcementBar.offsetHeight
                    if (header) topOffset += header.offsetHeight
                    mobileSearchModal.style.top = topOffset + 'px'
                }
            }
        })

        if (this.searchBar) {
            this.searchBar.addEventListener('input', () => {
                clearTimeout(this.debounceTimer)
                this.debounceTimer = setTimeout(async () => {
                    await this.queryResults()
                }, 300)
            })

            this.searchBar.addEventListener('focus', () => {
                const value = this.searchBar.value.trim()
                if (value !== '') {
                    this.showModal()
                }
            })

            this.searchBar.addEventListener('blur', () => {
                // Delay hiding to allow clicks on modal
                setTimeout(() => {
                    if (!this.modal.matches(':hover') && !this.searchBar.matches(':focus')) {
                        this.hideModal()
                    }
                }, 150)
            })
        }

        // Hide modal when clicking outside
        document.addEventListener('click', (e) => {
            if (!this.contains(e.target)) {
                this.hideModal()
            }
        })
    }

    initMobileSearch() {
        const mobileSearchTrigger = document.querySelector('#mobile-search-trigger')
        const mobileSearchModal = document.querySelector('#mobile-search-modal')
        const mobileSearchClose = document.querySelector('#mobile-search-close')
        const mobileSearchInput = document.querySelector('#mobile-search-input')

        console.log('Mobile Search Init:', {
            trigger: !!mobileSearchTrigger,
            modal: !!mobileSearchModal,
            close: !!mobileSearchClose,
            input: !!mobileSearchInput
        })

        if (!mobileSearchTrigger) {
            console.error('Mobile search trigger not found')
            return
        }

        if (!mobileSearchModal) {
            console.error('Mobile search modal not found')
            return
        }

        // Open mobile search modal
        mobileSearchTrigger.addEventListener('click', (e) => {
            e.preventDefault()
            e.stopPropagation()
            console.log('Mobile search trigger clicked')
            this.showMobileModal()
        })

        // Add touch event for mobile
        mobileSearchTrigger.addEventListener('touchend', (e) => {
            e.preventDefault()
            e.stopPropagation()
            console.log('Mobile search trigger touched')
            this.showMobileModal()
        })

        if (mobileSearchClose) {
            // Close mobile search modal
            mobileSearchClose.addEventListener('click', (e) => {
                e.preventDefault()
                this.hideMobileModal()
            })
        }

        // Mobile search functionality - Define functions first
        async function queryMobileResults() {
            console.log('queryMobileResults called')
            const currentSearch = mobileSearchInput.value.trim()
            console.log('Current search term:', currentSearch)

            if (currentSearch !== '') {
                try {
                    console.log('Making search request...')
                    const locale = this.getLocale()
                    const req = await fetch(`${locale}/search/suggest.json?q=${encodeURIComponent(currentSearch)}&section_id=predictive-search&resources[limit]=4&resources[limit_scope]=each`)
                    console.log('Search request completed:', req.status)

                    const responseData = await req.json()
                    console.log('Search response data:', responseData)

                    const { resources: { results: { products, queries } } } = responseData

                    console.log('Found products:', products?.length || 0)
                    console.log('Found queries:', queries?.length || 0)
                    renderMobileResults(products)
                    renderMobileSuggestions(queries)
                    await renderMobileCount()
                    showMobileSearchResults()
                } catch (error) {
                    console.error('Mobile search error:', error)
                }
            } else {
                console.log('Empty search, hiding results')
                hideMobileSearchResults()
            }
        }

        async function renderMobileCount() {
            const parser = new DOMParser()
            const countContainer = document.querySelector('#mobile-search-result-count')
            const termContainer = document.querySelector('#mobile-search-term')
            const link = document.querySelector('#mobile-all-search-results')
            const term = mobileSearchInput.value
            const locale = getLocalePrefix()
            const query = `${locale}/search?section_id=search-json&q=${term}`

            try {
                const data = await fetch(query)
                const html = parser.parseFromString(await data.text(), 'text/html')
                const count = JSON.parse(html.querySelector('#shopify-section-search-json').innerHTML)

                if (countContainer) countContainer.textContent = `${count.results_count} `
                if (termContainer) termContainer.textContent = `${term}`
                if (link) link.setAttribute('href', `${locale}/search?q=${encodeURIComponent(term)}`)
            } catch (error) {
                console.error('Mobile count render error:', error)
            }
        }

        function renderMobileSuggestions(queries) {
            const trendingContainer = document.querySelector('#trending-items')
            const trendingSection = document.querySelector('.mobile-trending-searches')

            if (!trendingContainer || !trendingSection) return

            // Hide section if no suggestions
            if (!queries || queries.length === 0) {
                trendingSection.style.display = 'none'
                return
            }

            // Show section and render suggestions
            trendingSection.style.display = 'block'

            const locale = getLocalePrefix()
            const suggestionsHTML = queries.map(query => {
                const searchTerm = query.text || query.styled_text
                return `<a href="${locale}/search?q=${encodeURIComponent(searchTerm)}" class="trending-item">${searchTerm}</a>`
            }).join('')

            trendingContainer.innerHTML = suggestionsHTML

            // Add click listeners to the new suggestion items
            const suggestionItems = trendingContainer.querySelectorAll('.trending-item')
            suggestionItems.forEach(item => {
                item.addEventListener('click', (e) => {
                    e.preventDefault()
                    const searchTerm = e.target.textContent.trim()
                    const mobileSearchInput = document.querySelector('#mobile-search-input')
                    if (mobileSearchInput) {
                        mobileSearchInput.value = searchTerm
                        this.queryMobileResults()
                    }
                })
            })
        }

        function showMobileSearchResults() {
            const mobileSearchBody = document.querySelector('.mobile-search-modal__body')
            const mobileSearchOverlay = document.querySelector('.mobile-search-modal__overlay')

            if (mobileSearchBody) {
                mobileSearchBody.classList.add('show')
            }
            if (mobileSearchOverlay) {
                mobileSearchOverlay.classList.add('show')
            }
        }

        function hideMobileSearchResults() {
            const mobileSearchBody = document.querySelector('.mobile-search-modal__body')
            const mobileSearchOverlay = document.querySelector('.mobile-search-modal__overlay')

            if (mobileSearchBody) {
                mobileSearchBody.classList.remove('show')
            }
            if (mobileSearchOverlay) {
                mobileSearchOverlay.classList.remove('show')
            }
        }

        function renderMobileResults(data) {
            const resultsContainer = document.querySelector('#mobile-search-results')
            if (!resultsContainer || !data) return

            if (data.length === 0) {
                resultsContainer.innerHTML = `<p style="padding: 20px; text-align: center; color: rgba(0,0,0,0.5);">${window.searchStrings.noProductsFound}</p>`
                return
            }

            const resultsHTML = data.map(product => {
                const price = product.price ? (product.price / 100).toFixed(2) : null
                const imageUrl = product.image || product.featured_image?.url

                return `
                    <a href="${product.url}" class="mobile-search-result-item">
                        ${imageUrl ? `
                            <img src="${imageUrl}" alt="${product.title}" class="mobile-search-result-item__image" loading="lazy">
                        ` : `
                            <div class="mobile-search-result-item__image" style="background-color: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #999;">No Image</div>
                        `}
                        <div class="mobile-search-result-item__title">${product.title}</div>
                        <div class="mobile-search-result-item__subtitle">${product.product_type || 'Product'}</div>
                        <div class="mobile-search-result-item__rating">
                            <span>★</span> (4.5)
                        </div>
                        <div class="mobile-search-result-item__price">
                            ${price ? `$${price}` : ''}
                        </div>
                    </a>
                `
            }).join('')

            resultsContainer.innerHTML = resultsHTML
        }

        // Handle trending search clicks
        const trendingItems = document.querySelectorAll('.trending-item')
        trendingItems.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault()
                const searchTerm = e.target.textContent.trim()
                if (mobileSearchInput) {
                    mobileSearchInput.value = searchTerm
                    queryMobileResults()
                }
            })
        })

        if (mobileSearchModal) {
            // Close modal when clicking outside content area
            mobileSearchModal.addEventListener('click', (e) => {
                if (e.target === mobileSearchModal) {
                    this.hideMobileModal()
                }
            })
        }
    }

    showMobileModal() {
        console.log('showMobileModal called')
        const mobileSearchModal = document.querySelector('#mobile-search-modal')
        const mobileSearchInput = document.querySelector('#mobile-search-input')

        console.log('Modal element found:', !!mobileSearchModal)

        if (mobileSearchModal) {
            console.log('Adding show class to modal')
            mobileSearchModal.classList.add('show')

            // Only hide body overflow on mobile screens (below 989px)
            if (window.innerWidth < 989) {
                document.body.style.overflow = 'hidden'
            }

            // Ensure content sections are hidden when modal opens with empty search
            this.hideMobileResults()

            // Focus on search input after modal is shown
            setTimeout(() => {
                if (mobileSearchInput) {
                    mobileSearchInput.focus()
                }
            }, 100)
        } else {
            console.error('Mobile search modal not found when trying to show')
        }
    }

    hideMobileModal() {
        const mobileSearchModal = document.querySelector('#mobile-search-modal')
        const mobileSearchInput = document.querySelector('#mobile-search-input')
        const mobileSearchResults = document.querySelector('.mobile-search-results-section')
        const mobileTrendingSearches = document.querySelector('.mobile-trending-searches')

        if (mobileSearchModal) {
            mobileSearchModal.classList.remove('show')
            document.body.style.overflow = ''

            // Clear search input and reset view
            if (mobileSearchInput) {
                mobileSearchInput.value = ''
            }

            // Hide all sections when modal is closed
            if (mobileSearchResults) {
                mobileSearchResults.classList.remove('show')
            }
            if (mobileTrendingSearches) {
                mobileTrendingSearches.classList.remove('show')
            }
        }
    }

    async queryMobileResults() {
        const mobileSearchInput = document.querySelector('#mobile-search-input')
        const currentSearch = mobileSearchInput.value.trim()

        if (currentSearch !== '') {
            try {
                // Fetch rendered results from Liquid template
                const parser = new DOMParser()
                const renderedReq = await fetch(`${this.locale}/search?q=${encodeURIComponent(currentSearch)}&section_id=search-modal-results`)
                const renderedHtml = parser.parseFromString(await renderedReq.text(), 'text/html')

                // Fetch suggestions separately
                const suggestReq = await fetch(`${this.locale}/search/suggest.json?q=${encodeURIComponent(currentSearch)}&section_id=predictive-search&resources[limit]=4&resources[limit_scope]=each`)
                const { resources: { results: { queries } } } = await suggestReq.json()

                this.renderMobileResults(renderedHtml.querySelector('#shopify-section-search-modal-results').querySelector('.search-modal-results').innerHTML.toString())
                this.renderMobileSuggestions(queries)
                await this.renderMobileCount()
                this.showMobileResults()
            } catch (error) {
                console.error('Mobile search error:', error)
            }
        } else {
            this.hideMobileResults()
        }
    }

    async renderMobileCount() {
        const parser = new DOMParser()
        const countContainer = document.querySelector('#mobile-search-result-count')
        const termContainer = document.querySelector('#mobile-search-term')
        const link = document.querySelector('#mobile-all-search-results')
        const term = document.querySelector('#mobile-search-input').value
        const query = `${this.locale}/search?section_id=search-json&q=${term}`

        try {
            const data = await fetch(query)
            const html = parser.parseFromString(await data.text(), 'text/html')
            const count = JSON.parse(html.querySelector('#shopify-section-search-json').innerHTML)

            if (countContainer) countContainer.textContent = `${count.results_count} `
            if (termContainer) termContainer.textContent = `${term}`
            if (link) link.setAttribute('href', `${this.locale}/search?q=${encodeURIComponent(term)}`)
        } catch (error) {
            console.error('Mobile count render error:', error)
        }
    }

    renderMobileSuggestions(queries) {
        const trendingContainer = document.querySelector('#trending-items')
        const trendingSection = document.querySelector('.mobile-trending-searches')

        if (!trendingContainer || !trendingSection) return

        // Hide section if no suggestions
        if (!queries || queries.length === 0) {
            trendingSection.style.display = 'none'
            return
        }

        // Show section and render suggestions
        trendingSection.style.display = 'block'

        const suggestionsHTML = queries.map(query => {
            const searchTerm = query.text || query.styled_text
            return `<a href="${this.locale}/search?q=${encodeURIComponent(searchTerm)}" class="trending-item">${searchTerm}</a>`
        }).join('')

        trendingContainer.innerHTML = suggestionsHTML

        // Add click listeners to the new suggestion items
        const suggestionItems = trendingContainer.querySelectorAll('.trending-item')
        suggestionItems.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault()
                const searchTerm = e.target.textContent.trim()
                const mobileSearchInput = document.querySelector('#mobile-search-input')
                if (mobileSearchInput) {
                    mobileSearchInput.value = searchTerm
                    this.queryMobileResults()
                }
            })
        })
    }

    showMobileResults() {
        const mobileSearchResults = document.querySelector('.mobile-search-results-section')
        const mobileTrendingSearches = document.querySelector('.mobile-trending-searches')

        if (mobileSearchResults) {
            mobileSearchResults.classList.add('show')
        }
        if (mobileTrendingSearches) {
            mobileTrendingSearches.classList.add('show')
        }
    }

    hideMobileResults() {
        const mobileSearchResults = document.querySelector('.mobile-search-results-section')
        const mobileTrendingSearches = document.querySelector('.mobile-trending-searches')

        if (mobileSearchResults) {
            mobileSearchResults.classList.remove('show')
        }
        if (mobileTrendingSearches) {
            mobileTrendingSearches.classList.remove('show')
        }
    }

    renderMobileResults(htmlString) {
        const resultsContainer = document.querySelector('#mobile-search-results')
        if (!resultsContainer) return

        if (!htmlString || htmlString.trim() === '') {
            resultsContainer.innerHTML = `<p style="padding: 20px; text-align: center; color: rgba(0,0,0,0.5);">${window.searchStrings.noProductsFound}</p>`
            return
        }

        resultsContainer.innerHTML = htmlString
    }

    async queryResults() {
        const currentSearch = this.searchBar.value.trim()

        if (currentSearch !== '') {
            try {
                // Fetch rendered results from Liquid template
                const parser = new DOMParser()
                const renderedReq = await fetch(`${this.locale}/search?q=${encodeURIComponent(currentSearch)}&section_id=search-modal-results`)
                const renderedHtml = parser.parseFromString(await renderedReq.text(), 'text/html')

                // Fetch suggestions separately
                const suggestReq = await fetch(`${this.locale}/search/suggest.json?q=${encodeURIComponent(currentSearch)}&section_id=predictive-search&resources[limit]=3&resources[limit_scope]=each`)
                const { resources: { results: { queries } } } = await suggestReq.json()

                this.renderResults(renderedHtml.querySelector('#shopify-section-search-modal-results').querySelector('.search-modal-results').innerHTML.toString())
                await this.renderCount()
                this.renderTermSuggestions(queries)
                this.showModal()
            } catch (error) {
                console.error('Search error:', error)
            }
        } else {
            this.hideModal()
        }
    }

    async renderCount() {
        const parser = new DOMParser();
        const countContainer = document.querySelector('#search-result-count')
        const termContainer = document.querySelector('#search-term')
        const link = document.querySelector('#all-search-results')
        const term = document.querySelector('#search-bar').value
        const query = `${this.locale}/search?section_id=search-json&q=${term}`

        const data = await fetch(query)
        const html = parser.parseFromString(await data.text(), 'text/html')

        const count = JSON.parse(html.querySelector('#shopify-section-search-json').innerHTML)

        if (this.noResults) countContainer.textContent = "0 "
        else countContainer.textContent = `${count.results_count} `

        termContainer.textContent = `"${term}"`
        link.setAttribute('href', `${this.locale}/search?q=${encodeURIComponent(term)}`)
    }

    showModal() {
        if (this.modal) {
            this.modal.style.display = 'block'
            // Use setTimeout to ensure display change is applied before adding class
            setTimeout(() => {
                this.modal.classList.add('show')
            }, 10)
        }
    }

    hideModal() {
        if (this.modal) {
            this.modal.classList.remove('show')
            setTimeout(() => {
                this.modal.style.display = 'none'
            }, 300) // Match CSS transition duration
        }
    }

    renderTermSuggestions(data) {
        const suggestionsContainer = document.querySelector('#search-suggestions')
        if (!suggestionsContainer || !data) return

        if (data.length === 0) {
            suggestionsContainer.innerHTML = `<p style="padding: 20px; text-align: center; color: rgba(0,0,0,0.5);">${window.searchStrings.noSuggestionsFound}</p>`
            return
        }

        const suggestionsHTML = data.map(query => {
            return `
                <a href="${this.locale}/search?q=${encodeURIComponent(query.text)}" class="search-suggestion-item">
                    ${query.text}
                </a>
            `
        }).join('')

        suggestionsContainer.innerHTML = suggestionsHTML
    }

    renderResults(htmlString) {
        const resultsContainer = document.querySelector('#search-results')
        if (!resultsContainer) return

        if (!htmlString || htmlString.trim() === '') {
            this.noResults = true
            resultsContainer.innerHTML = `<p style="padding: 20px; text-align: center; color: rgba(0,0,0,0.5);">${window.searchStrings.noProductsFound}</p>`
            return
        }

        this.noResults = false
        resultsContainer.innerHTML = htmlString
    }
}

customElements.define('custom-search', CustomSearch)

// Helper function to get locale prefix for fallback code
function getLocalePrefix() {
    const locale = window.Shopify?.locale
    const pathMatch = window.location.pathname.match(/^\/([a-z]{2})(?:\/|$)/)
    return pathMatch && pathMatch[1] === locale ? `/${locale}` : ''
}

// Fallback mobile search initialization if custom element hasn't loaded
document.addEventListener('DOMContentLoaded', function() {
    // Wait a bit more to ensure all elements are rendered
    setTimeout(() => {
        const mobileSearchTrigger = document.querySelector('#mobile-search-trigger')
        const mobileSearchModal = document.querySelector('#mobile-search-modal')

        console.log('DOMContentLoaded fallback check:', {
            trigger: !!mobileSearchTrigger,
            modal: !!mobileSearchModal
        })

        if (mobileSearchTrigger && mobileSearchModal && !mobileSearchTrigger.hasAttribute('data-mobile-initialized')) {
            console.log('Initializing mobile search via fallback')
            mobileSearchTrigger.setAttribute('data-mobile-initialized', 'true')

            // Add resize listener to handle viewport changes
            window.addEventListener('resize', () => {
                if (window.innerWidth >= 989) {
                    document.body.style.overflow = ''
                } else {
                    // If back to mobile and modal is open, reapply mobile behavior
                    if (mobileSearchModal && mobileSearchModal.classList.contains('show')) {
                        document.body.style.overflow = 'hidden'
                        // Recalculate and update modal position
                        const announcementBar = document.querySelector('.announcement-bar-section, .announcement-bar')
                        const header = document.querySelector('.header, .section-header')
                        let topOffset = 0
                        if (announcementBar) topOffset += announcementBar.offsetHeight
                        if (header) topOffset += header.offsetHeight
                        mobileSearchModal.style.top = topOffset + 'px'
                    }
                }
            })

            const mobileSearchClose = document.querySelector('#mobile-search-close')
            const mobileSearchInput = document.querySelector('#mobile-search-input')

            console.log('Found elements:', {
                trigger: !!mobileSearchTrigger,
                modal: !!mobileSearchModal,
                close: !!mobileSearchClose,
                input: !!mobileSearchInput
            })

            console.log('Mobile search input element:', mobileSearchInput)

            // Define mobile search functions in the correct scope
            async function queryMobileResults() {
                console.log('queryMobileResults called')
                const currentSearch = mobileSearchInput.value.trim()
                console.log('Current search term:', currentSearch)

                if (currentSearch !== '') {
                    try {
                        console.log('Making search request...')

                        // Fetch rendered results from Liquid template
                        const parser = new DOMParser()
                        const locale = getLocalePrefix()
                        const renderedReq = await fetch(`${locale}/search?q=${encodeURIComponent(currentSearch)}&section_id=search-modal-results`)
                        const renderedHtml = parser.parseFromString(await renderedReq.text(), 'text/html')

                        // Fetch suggestions separately
                        const suggestReq = await fetch(`${locale}/search/suggest.json?q=${encodeURIComponent(currentSearch)}&section_id=predictive-search&resources[limit]=4&resources[limit_scope]=each`)
                        const { resources: { results: { queries } } } = await suggestReq.json()

                        console.log('Found queries:', queries?.length || 0)
                        renderMobileResults(renderedHtml.querySelector('#shopify-section-search-modal-results').querySelector('.search-modal-results').innerHTML.toString())
                        renderMobileSuggestions(queries)
                        await renderMobileCount()
                        showMobileSearchResults()
                    } catch (error) {
                        console.error('Mobile search error:', error)
                    }
                } else {
                    console.log('Empty search, hiding results')
                    hideMobileSearchResults()
                }
            }

            async function renderMobileCount() {
                const parser = new DOMParser()
                const countContainer = document.querySelector('#mobile-search-result-count')
                const termContainer = document.querySelector('#mobile-search-term')
                const link = document.querySelector('#mobile-all-search-results')
                const term = mobileSearchInput.value
                const locale = getLocalePrefix()
                const query = `${locale}/search?section_id=search-json&q=${term}`

                try {
                    const data = await fetch(query)
                    const html = parser.parseFromString(await data.text(), 'text/html')
                    const count = JSON.parse(html.querySelector('#shopify-section-search-json').innerHTML)

                    if (countContainer) countContainer.textContent = `${count.results_count} `
                    if (termContainer) termContainer.textContent = `${term}`
                    if (link) link.setAttribute('href', `${locale}/search?q=${encodeURIComponent(term)}`)
                } catch (error) {
                    console.error('Mobile count render error:', error)
                }
            }

            function renderMobileSuggestions(queries) {
                const trendingContainer = document.querySelector('#trending-items')
                const trendingSection = document.querySelector('.mobile-trending-searches')

                if (!trendingContainer || !trendingSection) return

                // Hide section if no suggestions
                if (!queries || queries.length === 0) {
                    trendingSection.style.display = 'none'
                    return
                }

                // Show section and render suggestions
                trendingSection.style.display = 'block'

                const locale = getLocalePrefix()
                const suggestionsHTML = queries.map(query => {
                    const searchTerm = query.text || query.styled_text
                    return `<a href="${locale}/search?q=${encodeURIComponent(searchTerm)}" class="trending-item">${searchTerm}</a>`
                }).join('')

                trendingContainer.innerHTML = suggestionsHTML

                // Add click listeners to the new suggestion items
                const suggestionItems = trendingContainer.querySelectorAll('.trending-item')
                suggestionItems.forEach(item => {
                    item.addEventListener('click', (e) => {
                        e.preventDefault()
                        const searchTerm = e.target.textContent.trim()
                        if (mobileSearchInput) {
                            mobileSearchInput.value = searchTerm
                            queryMobileResults()
                        }
                    })
                })
            }

            function showMobileSearchResults() {
                const mobileSearchBody = document.querySelector('.mobile-search-modal__body')
                const mobileSearchOverlay = document.querySelector('.mobile-search-modal__overlay')

                if (mobileSearchBody) {
                    mobileSearchBody.classList.add('show')
                }
                if (mobileSearchOverlay) {
                    mobileSearchOverlay.classList.add('show')
                }
            }

            function hideMobileSearchResults() {
                const mobileSearchBody = document.querySelector('.mobile-search-modal__body')
                const mobileSearchOverlay = document.querySelector('.mobile-search-modal__overlay')

                if (mobileSearchBody) {
                    mobileSearchBody.classList.remove('show')
                }
                if (mobileSearchOverlay) {
                    mobileSearchOverlay.classList.remove('show')
                }
            }

            function renderMobileResults(htmlString) {
                const resultsContainer = document.querySelector('#mobile-search-results')
                if (!resultsContainer) return

                if (!htmlString || htmlString.trim() === '') {
                    resultsContainer.innerHTML = `<p style="padding: 20px; text-align: center; color: rgba(0,0,0,0.5);">${window.searchStrings.noProductsFound}</p>`
                    return
                }

                resultsContainer.innerHTML = htmlString
            }

            // Set up search input event listeners immediately after finding the element
            if (mobileSearchInput) {
                console.log('Setting up mobile search input listener')
                console.log('Input element details:', {
                    id: mobileSearchInput.id,
                    tagName: mobileSearchInput.tagName,
                    type: mobileSearchInput.type
                })

                // Test if the element is interactive
                mobileSearchInput.addEventListener('focus', () => {
                    console.log('Mobile search input focused!')
                })

                let debounceTimer = null

                // Handle mobile search input
                mobileSearchInput.addEventListener('input', (e) => {
                    console.log('Mobile search input changed:', e.target.value)
                    clearTimeout(debounceTimer)
                    debounceTimer = setTimeout(async () => {
                        console.log('Executing search query...')
                        await queryMobileResults()
                    }, 300)
                })

                // Also try keyup as backup
                mobileSearchInput.addEventListener('keyup', (e) => {
                    console.log('Mobile search keyup:', e.target.value)
                })
            } else {
                console.error('Mobile search input not found for event listener')
            }

            function showModal() {
                console.log('Fallback: Showing modal')

                // Calculate total top offset (announcement bar + header)
                const announcementBar = document.querySelector('.announcement-bar-section, .announcement-bar')
                const header = document.querySelector('.header, .section-header')

                let topOffset = 0
                if (announcementBar) {
                    topOffset += announcementBar.offsetHeight
                    console.log('Announcement bar height:', announcementBar.offsetHeight)
                }
                if (header) {
                    topOffset += header.offsetHeight
                    console.log('Header height:', header.offsetHeight)
                }

                console.log('Total top offset:', topOffset)

                mobileSearchModal.classList.add('show')
                mobileSearchModal.style.display = 'block'
                mobileSearchModal.style.top = topOffset + 'px' // Position below header and announcement bar
                mobileSearchModal.style.zIndex = '1000'

                // Only hide body overflow on mobile screens (below 989px)
                if (window.innerWidth < 989) {
                    document.body.style.overflow = 'hidden'
                }

                // Ensure content sections are hidden when modal opens with empty search
                console.log('Hiding content sections on modal open')
                hideMobileSearchResults()

                // Debug: Check if sections are actually hidden
                const mobileSearchResultsSection = document.querySelector('.mobile-search-results-section')
                const mobileTrendingSearches = document.querySelector('.mobile-trending-searches')
                console.log('After hiding - Results section has show class:', mobileSearchResultsSection?.classList.contains('show'))
                console.log('After hiding - Trending searches has show class:', mobileTrendingSearches?.classList.contains('show'))

                if (mobileSearchInput) {
                    setTimeout(() => mobileSearchInput.focus(), 100)
                }
            }

            function hideModal() {
                mobileSearchModal.classList.remove('show')
                mobileSearchModal.style.display = 'none'
                document.body.style.overflow = ''

                if (mobileSearchInput) {
                    mobileSearchInput.value = ''
                }
            }

            // Simple mobile modal functionality
            mobileSearchTrigger.addEventListener('click', function(e) {
                e.preventDefault()
                e.stopPropagation()
                console.log('Fallback: Mobile search trigger clicked')
                showModal()
            })

            mobileSearchTrigger.addEventListener('touchend', function(e) {
                e.preventDefault()
                e.stopPropagation()
                console.log('Fallback: Mobile search trigger touched')
                showModal()
            })

            if (mobileSearchClose) {
                mobileSearchClose.addEventListener('click', function(e) {
                    e.preventDefault()
                    hideModal()
                })
            }

            // Close when clicking outside
            mobileSearchModal.addEventListener('click', function(e) {
                if (e.target === mobileSearchModal) {
                    hideModal()
                }
            })
        }
    }, 500)
})
